import axiosConfig from "./axiosConfig";

// One recorded lead search. Running a search records it - there is no save
// action - and the NAME is its identity, so re-running under the same name
// replaces that search's stored result set. See
// building-manager-api/docs/Y2026-Q3/design-lead-search-history.md.
export interface LeadSearchSummary {
  id: string;
  name: string;
  criteria: {
    postcodeOutward?: string | null;
    minFloorAreaSqm?: number | null;
    maxFloorAreaSqm?: number | null;
    radiusKm?: number | null;
    outcodes?: string[];
  };
  // What `sourceRefs` holds: VOA assessment refs, or platform site ids.
  sourceKind: "voa" | "existing_sites";
  // A standing search defined in code (the existing-site roof-area buckets)
  // rather than a run someone recorded. The backend seeds these once, at deploy,
  // and refuses both the delete and the rename - renaming one used to detach it
  // from the code that owns it - so the row hides both controls.
  isFixture: boolean;
  // Rows in the frozen set. Can be below `totalMatched` when the run was capped.
  // A bucket's count is as of its last refresh, which is now an explicit action
  // on the opened bucket rather than a side effect of opening it.
  resultCount: number;
  // How many of this search's own rows are leads now, whoever promoted them.
  // Counted off the row set, not the tag: a building found by two searches
  // keeps only the first one's tag, so a tag count read 0 for the second while
  // its rows still rendered as Lead. `/leads?savedSearch=<id>` narrows to
  // exactly this set, so the link shows the number the operator clicked.
  promotedCount: number;
  totalMatched: number;
  truncated: boolean;
  createdBy: string | null;
  createdAt: string;
  lastRunAt: string;
}

export interface LeadSearchesResponse {
  searches: LeadSearchSummary[];
}

const getLeadSearches = async (
  authToken: string
): Promise<LeadSearchesResponse> => {
  const { data } = await axiosConfig.get("/leads/searches", {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data;
};

export default getLeadSearches;
